import React from 'react';
import { Button } from '@abm-international/react-components';

export interface CommocatButtonProps {
	primary?: boolean;
	color?: string;
	className?: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	children?: React.ReactNode;
	style?: React.CSSProperties;
}

const CommocatButton: React.FC<CommocatButtonProps> = ({
	primary = true,
	color = 'green',
	className = '',
	onClick,
	children = 'DOEN',
	style
}) => (
	<Button
		primary={primary}
		color={color}
		className={`doen-btn ${className}`.trim()}
		onClick={onClick}
		style={style}
	>
		{children}
	</Button>
);

export default CommocatButton;
